import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';

import { SignatureFormComponent } from './signature-form.component';

import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@NgModule({
  declarations: [
    SignatureFormComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule,
    
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
  ],
  exports: [
    SignatureFormComponent,
  ]
})
export class SignatureModule { }
